// Module
var code = "<div class=\"modal-header\"> <h3>{{modalOptions.headerText}}</h3> </div> <div class=\"modal-body\">{{modalOptions.bodyText}}</div> <div class=\"modal-body\">{{modalOptions.bodyText2}}</div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" data-ng-click=\"modalOptions.ok()\"> {{modalOptions.actionButtonText}} </button> </div> ";
// Exports
export default code;